module.exports = __webpack_public_path__ + "img/energy.6ab0d4f9.svg";